export default "__VITE_ASSET__964958f2__"